import Image from 'next/image';
import Link from 'next/link';
import styles from './CollectionListingCard.module.scss';

export type CollectionListingCardProps = {
  title?: string;
  description?: string;
  image?: string;
  url: string;
};

export const CollectionListingCard = ({
  title,
  description,
  image,
  url,
}: CollectionListingCardProps) => {
  return (
    <Link href={url} className={styles.collectionListingCard}>
      <div className={styles.collectionListingCard__imageContainer}>
        {image && (
          <Image
            className={styles.collectionListingCard__image}
            src={image}
            alt=""
            fill
            sizes="(max-width: 1023px) 154px, 300px"
          />
        )}
      </div>
      <div className="footer">
        <h3
          className={[
            'text-heading-h5-mobile text-heading-h5-desktop',
            styles.collectionListingCard__title,
          ].join(' ')}
        >
          {title}
        </h3>
        <p className="text-body-1-mobile text-heading-h6-desktop">
          {description}
        </p>
      </div>
    </Link>
  );
};
